/**
 * @generated SignedSource<<e1b2c7bb6c185a2ee396c529ba9ee6c1>>
 * @relayHash 919c9ca638544bc098cdd4187f87cb9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 24133495f28f27ac85c4a4064df5da38ea3e480a7e2d0d9a4966c53d8857219d

import type { ConcreteRequest } from 'relay-runtime';
export type AppNetworkEgressCategoryExtension = "ANALYTICS" | "%future added value";
export type AppNetworkPermissionTypeExtension = "FETCH_BACKEND_SIDE" | "FETCH_CLIENT_SIDE" | "FONTS" | "FRAMES" | "IMAGES" | "MEDIA" | "NAVIGATION" | "SCRIPTS" | "STYLES" | "%future added value";
export type CapabilitySet = "capabilityAdvanced" | "capabilityStandard" | "%future added value";
export type DataClassificationPolicyDecisionStatus = "ALLOWED" | "BLOCKED" | "%future added value";
export type EcosystemLicenseMode = "USER_ACCESS" | "%future added value";
export type ExtensionContextsFilterType = "APP_ID_ENVIRONMENT_ID" | "DATA_CLASSIFICATION_TAG" | "DEFINITION_ID" | "EXTENSION_TYPE" | "PRINCIPAL_TYPE" | "%future added value";
export type ExtensionContextsFilter = {
  type: ExtensionContextsFilterType;
  value: ReadonlyArray<string>;
};
export type useExtensionList_forge_ui_Query$variables = {
  contextIds: ReadonlyArray<string>;
  dataClassificationTags: ReadonlyArray<string>;
  filter: ReadonlyArray<ExtensionContextsFilter>;
  locale?: string | null;
};
export type useExtensionList_forge_ui_Query$data = {
  readonly extensionContexts: ReadonlyArray<{
    readonly extensions: ReadonlyArray<{
      readonly appId: string;
      readonly appOwner: {
        readonly name: string;
      } | null;
      readonly appVersion: string | null;
      readonly consentUrl: string | null;
      readonly currentUserConsent: {
        readonly appEnvironmentVersion: {
          readonly id: string;
        };
        readonly consentedAt: AGG$DateTime;
        readonly user: {
          readonly aaid: string;
        };
      } | null;
      readonly dataClassificationPolicyDecision: {
        readonly status: DataClassificationPolicyDecisionStatus;
      };
      readonly egress: ReadonlyArray<{
        readonly addresses: ReadonlyArray<string> | null;
        readonly category: AppNetworkEgressCategoryExtension | null;
        readonly inScopeEUD: boolean | null;
        readonly type: AppNetworkPermissionTypeExtension | null;
      }> | null;
      readonly environmentId: string;
      readonly environmentKey: string;
      readonly environmentType: string;
      readonly id: string;
      readonly installationConfig: ReadonlyArray<{
        readonly key: string;
        readonly value: boolean;
      }> | null;
      readonly installationId: string;
      readonly key: string;
      readonly license: {
        readonly active: boolean;
        readonly billingPeriod: string | null;
        readonly capabilitySet: CapabilitySet | null;
        readonly ccpEntitlementId: string | null;
        readonly ccpEntitlementSlug: string | null;
        readonly isEvaluation: boolean | null;
        readonly modes: ReadonlyArray<EcosystemLicenseMode> | null;
        readonly subscriptionEndDate: AGG$DateTime | null;
        readonly supportEntitlementNumber: string | null;
        readonly trialEndDate: AGG$DateTime | null;
        readonly type: string | null;
      } | null;
      readonly migrationKey: string | null;
      readonly properties: AGG$JSON;
      readonly remoteInstallationRegion: string | null;
      readonly requiresUserConsent: boolean | null;
      readonly sandboxPolicies: ReadonlyArray<string> | null;
      readonly scopes: ReadonlyArray<string>;
      readonly type: string;
      readonly userAccess: {
        readonly enabled: boolean;
        readonly hasAccess: boolean;
      } | null;
    }>;
    readonly id: string;
  }> | null;
};
export type useExtensionList_forge_ui_Query = {
  response: useExtensionList_forge_ui_Query$data;
  variables: useExtensionList_forge_ui_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dataClassificationTags"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v4 = [
  {
    "kind": "Variable",
    "name": "contextIds",
    "variableName": "contextIds"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "appId"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "environmentId"
},
v11 = {
  "kind": "ScalarField",
  "name": "environmentType"
},
v12 = {
  "kind": "ScalarField",
  "name": "environmentKey"
},
v13 = {
  "kind": "ScalarField",
  "name": "properties"
},
v14 = {
  "kind": "ScalarField",
  "name": "type"
},
v15 = {
  "concreteType": "AppInstallationLicense",
  "kind": "LinkedField",
  "name": "license",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "active"
    },
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "supportEntitlementNumber"
    },
    {
      "kind": "ScalarField",
      "name": "trialEndDate"
    },
    {
      "kind": "ScalarField",
      "name": "subscriptionEndDate"
    },
    {
      "kind": "ScalarField",
      "name": "isEvaluation"
    },
    {
      "kind": "ScalarField",
      "name": "billingPeriod"
    },
    {
      "kind": "ScalarField",
      "name": "ccpEntitlementId"
    },
    {
      "kind": "ScalarField",
      "name": "ccpEntitlementSlug"
    },
    {
      "kind": "ScalarField",
      "name": "capabilitySet"
    },
    {
      "kind": "ScalarField",
      "name": "modes"
    }
  ]
},
v16 = {
  "concreteType": "UserAccess",
  "kind": "LinkedField",
  "name": "userAccess",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    },
    {
      "kind": "ScalarField",
      "name": "hasAccess"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "appVersion"
},
v18 = {
  "kind": "ScalarField",
  "name": "installationId"
},
v19 = {
  "kind": "ScalarField",
  "name": "remoteInstallationRegion"
},
v20 = {
  "kind": "ScalarField",
  "name": "migrationKey"
},
v21 = {
  "concreteType": "EcosystemAppInstallationConfigExtension",
  "kind": "LinkedField",
  "name": "installationConfig",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v22 = {
  "concreteType": "AppNetworkEgressPermissionExtension",
  "kind": "LinkedField",
  "name": "egress",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "addresses"
    },
    {
      "kind": "ScalarField",
      "name": "category"
    },
    {
      "kind": "ScalarField",
      "name": "inScopeEUD"
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "sandboxPolicies"
},
v24 = {
  "kind": "ScalarField",
  "name": "scopes"
},
v25 = {
  "kind": "ScalarField",
  "name": "consentUrl"
},
v26 = {
  "concreteType": "UserConsentExtension",
  "kind": "LinkedField",
  "name": "currentUserConsent",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserConsentExtensionUser",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "aaid"
        }
      ]
    },
    {
      "concreteType": "UserConsentExtensionAppEnvironmentVersion",
      "kind": "LinkedField",
      "name": "appEnvironmentVersion",
      "plural": false,
      "selections": [
        (v5/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "consentedAt"
    }
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "requiresUserConsent"
},
v28 = {
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "dataClassificationTags",
          "variableName": "dataClassificationTags"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "concreteType": "DataClassificationPolicyDecision",
  "kind": "LinkedField",
  "name": "dataClassificationPolicyDecision",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useExtensionList_forge_ui_Query",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "args": (v6/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "appOwner",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useExtensionList_forge_ui_Query",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "args": (v6/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "appOwner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v9/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "24133495f28f27ac85c4a4064df5da38ea3e480a7e2d0d9a4966c53d8857219d",
    "metadata": {},
    "name": "useExtensionList_forge_ui_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d41768abfeddffbb972d5bcc1a3eb55c";

export default node;
